{
  "responseShape": "Respons server tidak sesuai dengan format yang diharapkan — silakan muat ulang.",
  "badRequest": "Permintaan tidak valid. Silakan periksa masukan Anda.",
  "forbidden": "Anda tidak memiliki izin untuk melakukan tindakan ini.",
  "facilityRequired": "Pilih fasilitas di header untuk menggunakan modul ini.",
  "notFound": "Sumber daya tidak ditemukan.",
  "conflict": "Sumber daya sudah ada.",
  "validation": "Kesalahan validasi.",
  "tooManyRequests": "Terlalu banyak permintaan. Silakan coba lagi nanti.",
  "serverError": "Kesalahan server. Silakan coba lagi nanti.",
  "unexpected": "Terjadi kesalahan yang tidak terduga.",
  "network": "Kesalahan jaringan. Silakan periksa koneksi Anda.",
  "requestSetup": "Terjadi kesalahan. Silakan coba lagi.",
  "sessionExpired": "Sesi Anda telah berakhir. Silakan masuk kembali."
}
